export default __webpack_public_path__ + "static/media/hand-rock-wht.0a60a706.svg";